module.exports = __webpack_public_path__ + "static/media/evercellCarousel2.0c51eca8.png";